import { PageHero, CTABand } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import {
  Building2, Recycle, FlaskConical, Ruler, Layers, Sparkles, HardHat, Paintbrush,
} from "lucide-react";

const SERVICES = [
  { icon: Building2, title: "Office & Facility Relocation", desc: "End-to-end commercial moves — pre-move planning, systems furniture disassembly and reconfiguration, IT disconnect/reconnect coordination, and day-one readiness so your team never loses a workday." },
  { icon: Recycle, title: "Decommissioning Services", desc: "Full facility decommissioning: asset liquidation, furniture recycling, lease-end restoration, and broom-clean turnover delivered on schedule and on budget." },
  { icon: FlaskConical, title: "Biotech & Lab Services", desc: "Laboratory relocation with documented chain of custody — cold-chain sample transport, sensitive instrument handling, and coordination with EH&S and facilities teams." },
  { icon: Ruler, title: "Space Planning & Interior Design", desc: "Workplace strategy, test fits, and interior design that align your space with how your teams actually work — before a single box is packed." },
  { icon: Layers, title: "Commercial Flooring", desc: "Flooring experts for every industry: carpet, laminate, hardwood, and tile — specified, sourced, and installed with minimal disruption to operations." },
  { icon: Sparkles, title: "Corporate & Commercial Cleaning", desc: "Pre- and post-move commercial cleaning services, plus secure short-term storage for furniture, files, and equipment between phases." },
  { icon: HardHat, title: "Small Commercial Construction", desc: "Build-outs, punch-list work, and light construction managed alongside your move — one accountable partner from demolition to desk placement." },
  { icon: Paintbrush, title: "Painting Services", desc: "Interior painting and finish refresh so your new space is move-in ready, branded, and spotless on day one." },
];

export default function Workplace() {
  return (
    <main data-testid="workplace-page">
      <PageHero
        eyebrow="Workplace Solutions"
        title="Every transition, planned to the inch"
        subtitle="Planning, program management, and asset services for every transition — from single-office moves to full facility decommissioning."
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 0.08}
              className="group bg-white border border-slate-200 rounded-md p-7 hover:border-brand hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
              <span className="font-display text-xs font-bold text-brand/60">{String(i + 1).padStart(2, "0")}</span>
              <s.icon size={28} className="text-brand mt-3 mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="font-display font-semibold text-lg text-navy mb-2">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </main>
  );
}
